export default __webpack_public_path__ + "static/media/Flag_of_United_Arab_Emirates.ec29cb73.svg";